export const EManualExternalOrderStatus = {
  Pending: 0,
  Confirmed: 1,
  Cancelled: 2,
  Refunded: 3,
  Received: 4,
  Reconciled: 5,
} as const

export type EManualExternalOrderStatus = (typeof EManualExternalOrderStatus)[keyof typeof EManualExternalOrderStatus]
